<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-card>
        <v-card-title class="headline">{{$t('managePayoutAccounts.title')}}</v-card-title>
        <v-card-text>
          <span>{{$t('managePayoutAccounts.description')}}</span>
          <accounts-widget :loading="loading" :onAccountClicked="onAccountClicked"/>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeDialog()">
            <v-icon left>mdi-close-circle</v-icon>{{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <account-details-dialog v-if="selectedAccount" :account="selectedAccount" :visible="selectedAccount != null" :closeAction="closeDetailsDialog"/>
  </v-row>
</template>

<script>
import AccountDetailsDialog from './AccountDetailsDialog.vue';
// import { ACTION_LOAD_FRIENDS } from "@/plugins/store";
import AccountsWidget from "./AccountsWidget"

export default {
  name: "ManageAccountsDialog",
  components: {
    AccountsWidget,
    AccountDetailsDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
  },
  data: function() {
    return {
      dialog: false,
      loading: false,
      selectedAccount: undefined,
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "500";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    }
  },
  watch: {
    visible: function(val) {
      // console.log('visible changed to ' + val)
      this.dialog = val;
    },
    dialog: function(val) {
      // console.log("dialog changed to " + val);
      if (val === false) {
        this.closeAction();
      }
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    closeDialog() {
      this.closeAction();
    },
    onAccountClicked(account) {
      this.selectedAccount = account
    },
    closeDetailsDialog() {
      this.selectedAccount = undefined
    },
  }
};
</script>
<style scoped>
</style>